// extracted by mini-css-extract-plugin
module.exports = {"container":"Badges_container__a1vLG","badge":"Badges_badge__rp5by"};